

























import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { TaxTypes } from "@/data/enums/settings";

// Types
import { IClient, IClientBillingTaxForm } from "@/models/clients";

@Component
export default class ClientTaxTypeForm extends Mixins(HasValidation) {
  // Props

  @Prop({ required: true })
  public client!: IClient;

  @Prop({ default: false })
  public isSticky!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data

  public form = {} as IClientBillingTaxForm;
  public isProcessing = false;

  // Life-cycle methods

  public async created() {
    this.form = this.initForm();
  }

  // Methods

  public initForm() {
    return _.pick(this.client, ["tax_type"]);
  }

  public async validateBeforeSubmit() {
    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      this.isProcessing = true;

      await this.updateClientTaxSettings();

      this.$emit("refreshClient");

      if (!this.isSticky) {
        this.$store.dispatch("toast/show", {
          message: this.$t("_sentence.tax.settings_updated")
        });
      }
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public updateClientTaxSettings() {
    if (!this.formIsChanged) return Promise.resolve();

    return this.$store.dispatch(`data/${DataModules.CLIENTS}/update`, {
      id: this.client.id,
      data: this.form,
      vm: this
    });
  }

  public revertToInitialState() {
    this.form = this.initForm();
  }

  // Computed

  public get taxTypeValue(): TaxTypes {
    return this.client.tax_type;
  }

  public get isStaged() {
    return !!this.client?.staged_import;
  }

  public get formIsChanged() {
    return !this.$_.isEqual(this.form, this.initForm());
  }

  public get taxTypesOptions() {
    return [
      {
        value: TaxTypes.BRAND_INHERIT,
        leftLabel: this.$t("_sentence.tax.apply_brand_tax_rules_label"),
        desc: this.$t("_sentence.tax.apply_brand_tax_rules_desc")
      },
      {
        value: TaxTypes.ZERO_TAX,
        leftLabel: this.$t("_sentence.tax.apply_brand_tax_rules_zeroed_label"),
        desc: this.$t("_sentence.tax.apply_brand_tax_rules_zeroed_desc")
      },
      {
        value: TaxTypes.NO_TAX,
        leftLabel: this.$t("_sentence.tax.do_not_apply_tax_label"),
        desc: this.$t("_sentence.tax.do_not_apply_tax_desc")
      }
    ];
  }

  // Guarding

  public get canUpdate() {
    return this.$userCan("update_client");
  }

  // Watchers

  @Watch("client")
  public onClientDataChange() {
    this.form = this.initForm();
  }

  @Watch("formIsChanged")
  public onIsEnabledChange() {
    this.$emit("isEnabled", this.formIsChanged);
  }

  @Watch("isProcessing")
  public onIsProcessingChange() {
    this.$emit("isProcessing", this.isProcessing);

    if (!this.isProcessing && !this.hasErrors) {
      this.$emit("isEnabled", false);
    }
  }
}
